/* @flow */
import Entity from 'lib/Entity';
import OfficeHours from 'entities/OfficeHours';

import { cloneDeep } from 'lodash';

class ChatMember extends Entity {
  parse(response: Object) {
    const member = cloneDeep(response);
    member['office_hours'] = OfficeHours.fromJSON(member['office_hours']);
    return member;
  }

  getColor(): ?string {
    return this.get('color');
  }

  getFirstName(): string {
    return this.get('first_name');
  }

  getLastName(): string {
    return this.get('last_name');
  }

  getUserId(): number {
    return this.get('id');
  }

  getUuid(): string {
    return this.get('uuid');
  }

  getName(): string {
    return this.get('name');
  }

  getInitials(): ?string {
    return this.get('initials');
  }

  getSignature(): ?string {
    return this.get('signature');
  }

  setName(name: string) {
    return this.set({ name });
  }

  getRole(): ?string {
    return this.get('role');
  }

  getOfficeHours(): OfficeHours {
    return this.get('office_hours');
  }

  isBlocked(): bool {
    return this.get('blocked');
  }

  setOfficeHours(hours: OfficeHours) {
    return this.set({ office_hours: hours });
  }

  getChatEligibilityState() {
    return this.get('chat_eligibility_state');
  }

  isEligibleForChat() {
    return this.getChatEligibilityState() === 'eligible';
  }
}

export default ChatMember;



// WEBPACK FOOTER //
// ./src/entities/ChatMember.js